import { ChangeDetectionStrategy, Component, Inject, Input, Output, SimpleChanges } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { requiredSelect } from "../../formly-components/formlyHelpers";
import { BehaviorSubject, Subject } from "rxjs";
import { ApiService } from "../../services/api.service";
import { EXPORT_ICON } from "src/app/models/contextMenuIcons.model";
import { ConverterOptions } from "../../utils/config";
import * as XLSX from 'xlsx';
import { DataObjectTypeName } from "src/app/models/dataObject.model";

@Component({
  selector: 'app-export-timeseries-modal',
  template: `
    <h2 mat-dialog-title>Export</h2>
    <mat-dialog-content>
      <form [formGroup]="form" (ngSubmit)="onExport()">
        <div style="height: 240px">
          <formly-form [form]="form" [fields]="fields" [model]="model" (modelChange)="onModelChanged($event)"></formly-form>
        </div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" type="submit" (click)="onExport()">Save</button>
      <button mat-button (click)="onCancel()">Cancel</button>
    </mat-dialog-actions>
  `,
  styles: [
    `
    .custom-dropdown .ng-dropdown-panel-items.scroll-host {
      overflow-y: scroll;
      height: 93px;
    }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
})

export class ExportTimeseriesModalComponent {
  exportIcon = EXPORT_ICON;
  model: any = {}
  selectedFile: string | null = null;
  makeDropdownScrollable: boolean = true;
  form: any = new FormGroup({});
  fields: FormlyFieldConfig[] = [];
  timeSeriesDetails: any;
  partitionKey: any;
  dataObject: any;
  objectSubject = new BehaviorSubject<{
    revisionId: string;
    id: string;
    timezone: string;
    name?: string | null;
    uom?: string | null;
    granularity: string;
    partitionKey: string;
  } | null>(null);

  selectedObject: any;
  private exportConversionOptions$ = [
    { label: 'CSV (de)', value: 'csv_de', disabled: false },
    { label: 'CSV (en)', value: 'csv_en', disabled: false },
    { label: 'XLS', value: 'excel', disabled: false },
    { label: 'Endur Deal Import', value: 'endur_deal', disabled: true },
    { label: 'Endur Data Series Import', value: 'endur_dataseries', disabled: true },
  ];

  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<ExportTimeseriesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    // this.objectSubject.subscribe((object: any) => {
    //   this.selectedObject = object;
    //   console.log('Selected Object:', this.data);
    //   if (object && object.objectType && (object.objectType == DataObjectTypeName.ContractProfile || object.objectType == DataObjectTypeName.GenerationProfile)) {
    //     const optionsToEnable = ['endur_deal', 'endur_dataseries'];
    //     this.exportConversionOptions$.forEach(option => {
    //       if (optionsToEnable.includes(option.value)) {
    //         option.disabled = false;
    //       }
    //     });
    //   }
    //   this.fields = this.getConfig();
    // });
    this.selectedObject = this.data.objectSubject._value;
    if (this.selectedObject && this.selectedObject.objectType && (this.selectedObject.objectType == DataObjectTypeName.ContractProfile || this.selectedObject.objectType == DataObjectTypeName.GenerationProfile)) {
      const optionsToEnable = ['endur_deal', 'endur_dataseries'];
      this.exportConversionOptions$.forEach(option => {
        if (optionsToEnable.includes(option.value)) {
          option.disabled = false;
        }
      });
    }
    this.fields = this.getConfig();

  }

  exportToEndurDeal(data: any[][], exportFileName: any) {
    const flatArray = data.flat();
    const headers = ['Time', 'Volume'];
    let dataArray = [headers, ...flatArray.map(item => Object.values(item))];
    const ws: XLSX.WorkSheet | any = XLSX.utils.aoa_to_sheet(dataArray);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let C = range.s.c; C <= range.e.c; ++C) {
        for (let R = range.s.r + 1; R <= range.e.r; ++R) {
            const cellAddress = { c: C, r: R };
            const cellRef = XLSX.utils.encode_cell(cellAddress);
            if (C === 0) {
                // Format for Time column
                ws[cellRef].t = "d";
                ws[cellRef].z = "dd.mm.yyyy hh:mm:ss";
            }
            //  else if (C === 1) {
            //     // Format for Volume column
            //     ws[cellRef].z = "0.00";
            // }
        }
    }
    XLSX.writeFile(wb, `${exportFileName}.xlsx`);
    this.dialogRef.close();
  }

  exportToEndurDataSeries(data: any[][], exportFileName: any) {
    const flatArray = data.flat();
    const headers = ['startDate', 'endDate', 'volume'];
    let dataArray = [headers, ...flatArray.map(item => Object.values(item))];
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(dataArray);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${exportFileName}.xlsx`);
    this.dialogRef.close();
  }

  exportToXLSX(data: any[][], exportFileName: any) {
    const flatArray = data.flat();
    const headers = ['timestamp_local', 'value'];
    let dataArray = [headers, ...flatArray.map(item => Object.values(item))];
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(dataArray);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${exportFileName}.xlsx`);
    this.dialogRef.close();
  }
  exportToCSV(dataobjects: any) {
    const flatArray = dataobjects.flat();
    const headers = ['timestamp_local', 'value'];
    const dataArray = [headers, ...flatArray];
    const csvData = dataArray.map((item: any) => {
      const values = Object.values(item)
        .filter(value => value !== '');  // Remove empty strings

      return values.join(',');
    }).join('\n');
    return csvData;
  }

  exportData(csvContent: any, exportFileName: any) {
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${exportFileName}.csv`;
    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    this.dialogRef.close();
  }
  private formatValue(value: any, decimalSep: string): string {
    return value ? value.toString().replace('.', decimalSep) : '';
  }

  private convertToCSVGermanFormat(data: any[][]): string {
    const flatArray = data.flat();
    const headers = ['timestamp_local', 'value'];
    const dataArray = [headers, ...flatArray];
    const csvData = dataArray.map((item: any) => {
      const values = Object.values(item)
        .map(value => this.formatValue(value, ','))
        .filter(value => value !== '');  // Remove empty strings

      return values.join(';');
    }).join('\n');

    return csvData;
  }

  callExportOnSelection(selectedoption: any, res: any, exportedFileName: any, headerExport: boolean) {
    let internationalCSVData: any;
    let germanCSVData: any;
    switch (selectedoption) {
      case 'csv_en':
        internationalCSVData = this.exportToCSV(res);
        this.exportData(internationalCSVData, exportedFileName);
        return;
      case 'csv_de':
        germanCSVData = this.convertToCSVGermanFormat(res);
        this.exportData(germanCSVData, exportedFileName);
        return;
      case 'excel':
        this.exportToXLSX(res, exportedFileName);
        return;
      case 'endur_deal':
        this.exportToEndurDeal(res, exportedFileName);
        return;
      case 'endur_dataseries':
        this.exportToEndurDataSeries(res, exportedFileName);
        return;
      default:
        throw new Error('Invalid format option');
    }
  }

  onExport() {
    if (this.form.invalid) {
      return;
    }
    let selectedoption = this.model.exportOptions?.value;
    if (!selectedoption) {
      return;
    }
    let exportedFileName: any = null;
    if (this.data.dataObject && (this.data.dataObject.objectMeta || this.data.dataObject.generationProfileInfo)) {
      if (this.data.dataObject.objectMeta && (this.data.dataObject.objectMeta.name || this.data.dataObject.parentObject.objectMeta.name)) {
        exportedFileName = (this.data.dataObject.objectMeta.name || this.data.dataObject.parentObject.objectMeta.name);
      } else if (this.data.dataObject.generationProfileInfo) {
        exportedFileName = this.dataObject.generationProfileInfo.name || (this.selectedObject.id || 'Exported_TS')
      }
    } else if (this.selectedObject.timeSeriesName) {
      exportedFileName = this.selectedObject.timeSeriesName;
    } else {
      exportedFileName = (this.selectedObject.id || 'Exported_TS');
    }
    if (selectedoption == 'endur_deal') {
      this.apiService
        .GetEndurDealTS(this.selectedObject?.id, this.selectedObject?.revisionId).subscribe((res: any) => {
          this.callExportOnSelection(selectedoption, res, exportedFileName, true);
        })
    } else if(selectedoption == 'endur_dataseries') {
      this.apiService
      .GetEndurDataSeriesTS(this.selectedObject?.id, this.selectedObject?.revisionId).subscribe((res: any) => {
        this.callExportOnSelection(selectedoption, res, exportedFileName, true);
      })
    } else {
      this.apiService
        .GetAllTSDataObjects(this.selectedObject?.id, this.selectedObject?.revisionId).subscribe((res: any) => {
          this.callExportOnSelection(selectedoption, res, exportedFileName, false);
        })
    }
  }

  onModelChanged(model: any) {
  }

  getDelimiterOptions() {
    return ConverterOptions.map((option) => {
      return {
        label: option.name,
        value: option.name,
        disabled: false,
      };
    });
  }


  private getConfig(): FormlyFieldConfig[] {
    return [
      requiredSelect<any>(
        'exportOptions',
        'Export Options',
        this.exportConversionOptions$,
        'label',
        undefined,
        {
          templateOptions: {
            placeholder: 'Select export option',
            maxOptions: 10
          },
        },
        '27686cfb-20c4-4b5d-aaf3-ae2f614af0f9',

      )
    ];
  }

  onCancel() {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
